module.exports = __webpack_public_path__ + "static/media/vail-9.d96ebb8f.jpg";